import { Menu, Button, Text, rem, Burger } from "@mantine/core";
import {
	IconSettings,
	IconSearch,
	IconPhoto,
	IconMessageCircle,
	IconTrash,
	IconArrowsLeftRight,
	IconShoppingCart,
	IconHelp,
	IconExternalLink, IconBug
} from "@tabler/icons-react";
import { useCallback } from "react";
import { openLink } from "@shared/utils/helpers";
import { useTranslation } from "react-i18next";
import { emailStepStore } from "@entities/StepEmail/store/emailStepStore";
import { appStore } from "@/app/store/appStore";
import styles from "@entities/layout/ui/NavigationLeft/navigationLeft.module.scss";
import { useDisclosure } from "@mantine/hooks";

export function MenuBurger() {
	const { t } = useTranslation();

	const responseData = emailStepStore((state) => state.responseData);
	const { gameConfig, runningInLauncher } = appStore((state) => ({
		gameConfig: state.gameConfig,
		runningInLauncher: state.runningInLauncher
	}));
	const [authToken, storeModalOpen, settingsModalOpen, supportModalOpen] = appStore((state) => [
		state.authToken,
		state.storeModalOpen,
		state.settingsModalOpen,
		state.supportModalOpen
	]);
	const { setSupportModalOpen, setStoreModalOpen, setSettingsModalOpen } = appStore.getState();

	const ShopUrl = gameConfig.PublicWebClientConfig?.Launcher?.Links?.ShopUrl;
	const SupportUrl = gameConfig.PublicWebClientConfig?.Launcher?.Links?.SupportUrl;
	const HelpUrl = gameConfig.PublicWebClientConfig?.Launcher?.Links?.HelpUrl;

	const handleShopClick = useCallback(() => {
		if (ShopUrl) {
			// Перенаправляем пользователя на страницу магазина
			openLink(ShopUrl);
		} else {
			// Открываем модальное окно магазина, если URL не задан
			setStoreModalOpen(true);
		}
	}, [ShopUrl, setStoreModalOpen]);

	const handleSupportClick = useCallback(() => {
		if (SupportUrl) {
			// Перенаправляем пользователя на страницу поддержки
			openLink(SupportUrl);
			return;
		}
		// Открываем модальное окно поддержки, если URL не задан
		setSupportModalOpen(true);
	}, [SupportUrl, setSupportModalOpen]);


	const handleSettingsClick = () => {
		setSettingsModalOpen(true);
	};
	const [opened, { toggle }] = useDisclosure();

	return (
		<Menu position={"bottom-start"} shadow="md" width={200} onChange={toggle}>
			<Menu.Target>
				<Burger opened={opened}  />
			</Menu.Target>

			<Menu.Dropdown>
				<Menu.Item
					onClick={handleShopClick}
					leftSection={<IconShoppingCart style={{ width: rem(14), height: rem(14) }} />}
					rightSection={ShopUrl && <IconExternalLink style={{ width: rem(14), height: rem(14) }} />}
				>
					{t("store.shop")}
				</Menu.Item>
				{HelpUrl && (
					<Menu.Item
						onClick={()=>openLink(HelpUrl)}
						leftSection={<IconHelp style={{ width: rem(14), height: rem(14) }} />}
						rightSection={<IconExternalLink style={{ width: rem(14), height: rem(14) }} />}
					>
						{t("help")}
					</Menu.Item>
				)}
				<Menu.Item onClick={handleSupportClick} leftSection={<IconBug style={{ width: rem(14), height: rem(14) }} />}
						   rightSection={SupportUrl && <IconExternalLink style={{ width: rem(14), height: rem(14) }} />} >
					{t("bug_report")}
				</Menu.Item>
				{runningInLauncher &&
				<Menu.Item onClick={handleSettingsClick}
					leftSection={<IconSettings style={{ width: rem(14), height: rem(14) }} />}

				>
					{t("settings")}
				</Menu.Item>}
			</Menu.Dropdown>
		</Menu>
	);
}
